import { styled } from "@mui/material";

import TextField from "~frontend/components/forms/FormTextField";

export default styled(TextField)({
  margin: "-1px 4px 0 4px",
  width: "40px",

  "& label": {
    display: "none",
  },
  "& .MuiInputBase-root": {
    marginTop: "0 !important",
    fontSize: "12px",

    "&:before": {
      borderBottomStyle: "solid",
    },
  },

  "& .MuiInput-input": {
    paddingBottom: 0,
  },
});
